
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-file-link{
  display:flex;
  align-items:center;
  gap:var(--spacing-1);
  padding:var(--spacing-1) 0;
  font-family:var(--ff-dmsans);
  color:var(--brand-neutral-gray-900);
  text-decoration:none;
  font-size:var(--fs-sm);
}
  .se-file-link > outline-icon{
    color:var(--brand-neutral-gray-900);
  }
  .se-file-link__file-size{
    display:contents;
    color:var(--brand-neutral-gray-600);
    font-size:var(--fs-xs);
  }
  .se-file-link:hover{
    text-decoration:underline;
  }
  .se-file-link .visually-hidden{
    position:absolute !important;
    overflow:hidden;
    clip:rect(1px, 1px, 1px, 1px);
    width:1px;
    height:1px;
    word-wrap:normal;
  }
`;